module.exports = __webpack_public_path__ + "static/media/h5_game_bottom_bg.d234dfbb.png";